import React from 'react'
import { Form, FormGroup, ControlLabel, FormControl, Button, ButtonToolbar } from 'react-bootstrap'

const emailRegex = '^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'

export default class Organization extends React.Component {

  constructor(props, context) {
    super(props, context)

    this.handleChange = this.handleChange.bind(this)
    this.handlePost = this.handlePost.bind(this)

    this.state = {
      organization: this.props.organization
    }
  }

  handleChange(e) {
    const key = e.target.id
    const organization = this.state.organization
    organization[key] = e.target.value
    this.setState({organization: organization})
  }

  handlePost() {
    this.props.updateCallback(this.state.organization)
  }

  handleCancel() {

  }

  validate() {
    const {organization} = this.state
    const isEmailValid = new RegExp(emailRegex).test(organization.email)
    return (isEmailValid && organization.firstName && organization.lastName && organization.name )
  }

  render() {
    const {organization} = this.state

    return (
      <div>
        <Form onSubmit={ e => e.preventDefault()}>
          <FormGroup controlId="name"> 
            <ControlLabel>Organisatienaam *</ControlLabel>
            <FormControl onChange={this.handleChange} type="text" value={organization.name} />
          </FormGroup>
          <FormGroup controlId="userName">                                   
            <ControlLabel>Gebruikersnaam *</ControlLabel>
            <FormControl onChange={this.handleChange} type="text" value={organization.userName} />
          </FormGroup>
          <FormGroup controlId="firstName">                                   
            <ControlLabel>Voornaam *</ControlLabel>
            <FormControl onChange={this.handleChange} type="text" value={organization.firstName} />
          </FormGroup>
          <FormGroup controlId="prefix">
            <ControlLabel>Tussenvoegsel</ControlLabel>
            <FormControl onChange={this.handleChange} type="text" value={organization.prefix} />
          </FormGroup>
          <FormGroup controlId="lastName">
            <ControlLabel>Achternaam *</ControlLabel>
            <FormControl onChange={this.handleChange} type="text" value={organization.lastName} />
          </FormGroup>
          <FormGroup controlId="function">
            <ControlLabel>Functie</ControlLabel>
            <FormControl onChange={this.handleChange} type="text" value={organization.function} />
          </FormGroup>
          <FormGroup controlId="phone">
            <ControlLabel>Telefoon</ControlLabel>
            <FormControl onChange={this.handleChange} type="text" value={organization.phone} />
          </FormGroup>
          <div className="account-section">
            <FormGroup controlId="email">
              <ControlLabel>E-mail *</ControlLabel>
              <FormControl onChange={this.handleChange} type="email" value={organization.email} />
            </FormGroup>
          </div>
        </Form> 

        <div className="table-actions">
          <ButtonToolbar>
            <Button onClick={this.handleCancel}>Annuleren</Button>
            <Button bsStyle="primary" disabled={!this.validate()} onClick={() => this.handlePost()}>Opslaan</Button>
          </ButtonToolbar>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/Account/components/Organization.js